export default {
  notifications: [],
  unopenedNotifications: [],
};
